/**
 * Emotion Setup
 * 
 * This utility ensures that Emotion is properly set up to prevent
 * multiple instance loading issues.
 * 
 * @author Andres Nava
 * @version 1.0.0
 */

// Ensure Emotion is properly configured globally
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { readCspNonce } from './cspNonce';
// import { logger } from "./logger";
// Nonce lets Emotion's runtime <style> tags satisfy style-src without 'unsafe-inline'.
const cspNonce = typeof document !== 'undefined' ? readCspNonce(document) : undefined;
const emotionCache = createCache({
  key: 'css',
  prepend: true,
  ...(cspNonce ? { nonce: cspNonce } : {}),
});

// Global Emotion setup
if (typeof window !== 'undefined') {
  // Ensure we only have one Emotion instance
  if (!(window as any).__EMOTION_CACHE__) {
    (window as any).__EMOTION_CACHE__ = emotionCache;
  }
}

export { emotionCache, CacheProvider, ThemeProvider, CssBaseline };
